export const GET_CONFIG = 'GET_CONFIG'
export const GET_CONFIG_PENDING = 'GET_CONFIG_PENDING'
export const GET_CONFIG_SUCCESS = 'GET_CONFIG_SUCCESS'
export const GET_CONFIG_FAILURE = 'GET_CONFIG_FAILURE'